import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    private sidebarOpenSubject = new BehaviorSubject<boolean>(false);
    sidebarOpen$ = this.sidebarOpenSubject.asObservable();

    private sidebarMobleOpenSubject = new BehaviorSubject<boolean>(false);
    sidebarMobleOpen$ = this.sidebarMobleOpenSubject.asObservable();

    constructor(private router: Router) { }

    getMenuItems() {
        return this.router.config
          .filter(route => route.data && route.data['menu']&& route.data['menu'].show === true)
          .map(route => {
            return {
              ...route.data?.['menu'],
              path: route.data?.['menu'].childPath || route.path || '', 
            };
          })
          .sort((a, b) => a.order - b.order);
      }

    toggleSidebar() {
        const currentState = this.sidebarOpenSubject.value;
          this.sidebarOpenSubject.next(!currentState);
      }

      toggleMobileSidebar() {
        const currentState = this.sidebarMobleOpenSubject.value;
          this.sidebarMobleOpenSubject.next(!currentState);
      }
}